function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { postApi } from '../api';
import CryptoJS from 'crypto-js/crypto-js';
import filetype from 'magic-bytes.js'; // 默认的 KEY 与 iv 如果没有给

var KEY = CryptoJS.enc.Utf8.parse('12345678901234561234567890123456'); // ""中与后台一样

var IV = CryptoJS.enc.Utf8.parse(''); // ""中与后台一样

var Tool = /*#__PURE__*/function () {
  function Tool() {
    _classCallCheck(this, Tool);
  }

  _createClass(Tool, [{
    key: "isIE",
    value: // 是否IE浏览器
    function isIE() {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
    }
    /**
       * @param pcodes: 查询字典表入参集合，em：['peb_order_source']
       * @callback: 带有处理后的总体数据
       * */

  }, {
    key: "getDic",
    value: function () {
      var _getDic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(pcodes, callback) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Tool.getCodeData(pcodes);

              case 2:
                res = _context.sent;
                // 在这里把后端返回的res处理一下，尽量把原有的pcode摘出来
                res = Tool.handleDic(res);
                callback && callback(res);
                return _context.abrupt("return", res);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getDic(_x, _x2) {
        return _getDic.apply(this, arguments);
      }

      return getDic;
    }()
  }, {
    key: "replaceObjKeys",
    value:
    /**
       * 数据适配
       * param data：需要适配的数据源（Array，Object）
       * param arr1：需要替换的key值集合（Array）
       * param arr2：替换后的key值集合（Array）
       * param savaAll：是否同时保留替换前后的key（布尔值）
       * */
    function replaceObjKeys(data, arr1, arr2, saveAll) {
      // 多组对象
      if (Array.isArray(data)) {
        var arr = data.map(function (item) {
          var obj = {};

          _.forEach(arr1, function (val, i) {
            obj[arr2[i]] = item[val];
          });

          if (saveAll) {
            return _.extend(obj, item);
          }

          return obj;
        });
        return JSON.parse(JSON.stringify(arr));
      }

      _.forEach(arr1, function (item, i) {
        data[arr2[i]] = data[item];
      });

      return _.extend({}, data);
    } // 四则运算化成整数计算方法

  }, {
    key: "floatCalc",
    value: function floatCalc(a, b) {
      a = a + '';
      b = b + '';
      var aNum = a.indexOf('.'),
          bNum = b.indexOf('.'),
          aSum,
          bSum,
          resultNum,
          inta,
          intb;
      aSum = aNum < 0 ? 0 : a.split('.')[1].length;
      bSum = bNum < 0 ? 0 : b.split('.')[1].length;
      resultNum = aSum > bSum ? aSum : bSum;
      inta = aNum < 0 ? Number(a + (Math.pow(10, resultNum) + '').replace('1', '')) : function () {
        a = a.replace('.', '');
        a = resultNum == aSum ? a : a + (Math.pow(10, resultNum - aSum) + '').replace('1', '');
        return Number(a);
      }();
      intb = bNum < 0 ? Number(b + (Math.pow(10, resultNum) + '').replace('1', '')) : function () {
        b = b.replace('.', '');
        b = resultNum == bSum ? b : b + (Math.pow(10, resultNum - bSum) + '').replace('1', '');
        return Number(b);
      }();
      return {
        a: inta,
        b: intb,
        num: resultNum
      };
    } // 限制只能输入整数、小数且最多两位小数

  }, {
    key: "limitToNum",
    value: function limitToNum(data) {
      var num = data.replace(/[^\d.]/g, '') // 只允许一个小数点
      .replace(/^\./g, '').replace(/\.{2,}/g, '.') // 只能输入小数点后两位
      .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      return num;
    } // 根据参数限制输入小数位数

  }, {
    key: "limitToFloat",
    value: function limitToFloat(data) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var num;

      if (decimals == 0) {
        num = data.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+).*$/, '$1$2');
      } else {
        var d = '';

        for (var i = 0; i < decimals; i++) {
          d += "\\d";
        }

        var reg = new RegExp("^(\\-)*(\\d+)\\.(".concat(d, ").*$"));
        num = data.replace(/[^\d.]/g, '') // 只允许一个小数点
        .replace(/^\./g, '').replace(/\.{2,}/g, '.') // 只能输入小数点后两位
        .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(reg, '$1$2.$3');
      }

      return num;
    } // 限制只能输入整数

  }, {
    key: "limitToInt",
    value: function limitToInt(data) {
      var num = data.replace(/[^\d]/g, '');
      return num;
    } // 保留两位小数

  }, {
    key: "rounding",
    value: function rounding(mVal) {
      mVal = !mVal ? 0 : mVal;
      mVal = String(mVal);
      mVal = mVal == '[]' ? 0 : mVal;

      if (mVal.indexOf('.') == -1) {
        mVal += '.00';
      } else {
        var iFra = 0; // 小数部分

        var iInt = 0; // 整数部分

        var mValArr = mVal.split('.');
        iInt = mValArr[0];
        var iFraArr = mValArr[1].split('');

        if (iFraArr.length > 2) {
          if (iFraArr[2] - 0 > 4) {
            if (iFraArr[1] == 9) {
              if (iFraArr[0] == 9) {
                iFra = '00';
                iInt = iInt - 0 + 1;
              } else {
                iFra = '' + (iFra[0] - 0 + 1) + '0';
              }
            } else {
              iFra = '' + iFra[0] + (iFra[1] - 0 + 1);
            }
          } else {
            iFra = iFraArr[0] + iFraArr[1];
          }
        } else if (iFraArr.length == 1) {
          iFra = mValArr[1] + '0';
        } else {
          iFra = mValArr[1];
        }

        mVal = iInt + '.' + iFra;
      }

      return mVal;
    }
  }, {
    key: "typeOf",
    value: function typeOf(obj) {
      var toString = Object.prototype.toString;
      var map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
      };
      return map[toString.call(obj)];
    } // 深拷贝

  }, {
    key: "deepCopy",
    value: function deepCopy(data) {
      var t = this.typeOf(data);
      var o;

      if (t === 'array') {
        o = [];
      } else if (t === 'object') {
        o = {};
      } else {
        return data;
      }

      if (t === 'array') {
        for (var i = 0; i < data.length; i++) {
          o.push(this.deepCopy(data[i]));
        }
      } else if (t === 'object') {
        for (var _i in data) {
          o[_i] = this.deepCopy(data[_i]);
        }
      }

      return o;
    } // js将一个数组arr1 push到另一个数组arr2并去重

  }, {
    key: "mergerArr",
    value: function mergerArr(arr1, arr2) {
      var flag;

      for (var i = 0; i < arr1.length; i++) {
        flag = false;

        for (var j = 0; j < arr2.length; j++) {
          if (arr1[i] == arr2[j]) {
            flag = true;
            break;
          }
        }

        if (!flag) {
          arr2.push(arr1[i]);
        }
      }

      return arr2;
    }
    /**
       * 获取url后面的参数
       * @param name
       * @returns {string}
       */

  }, {
    key: "getQueryString",
    value: function getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg); // 获取url中"?"符后的字符串并正则匹配

      var context = '';
      if (r != null) context = r[2];
      reg = null;
      r = null;
      return context == null || context == '' || context == 'undefined' ? '' : context;
    } // aes加密

  }, {
    key: "Encrypt",
    value: function Encrypt(word, keyStr, ivStr) {
      var key = keyStr || KEY;
      var iv = ivStr || IV;
      key = CryptoJS.enc.Utf8.parse(key);
      iv = CryptoJS.enc.Utf8.parse(iv);
      var srcs = CryptoJS.enc.Utf8.parse(word);
      var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.ciphertext.toString();
    } // 检验文件类型

  }, {
    key: "canUpload",
    value: function canUpload(file) {
      var includeTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['jpg', 'png', 'jpeg', 'bmp', 'tif', 'tiff'];
      var suffix = file.name.slice(file.name.lastIndexOf('.') + 1);

      if (includeTypes.includes(suffix)) {
        // 无法获得签名类型
        var excludeType = ['docx', 'txt'];

        if (excludeType.includes(suffix)) {
          return Promise.resolve({
            isSuccess: true
          });
        }
      }

      return new Promise(function (res, rej) {
        if (file) {
          var fileReader = new FileReader();

          fileReader.onloadend = function (f) {
            var bytes = new Uint8Array(f.target.result);
            var info = filetype(bytes);

            if (info && info.length) {
              var flag = false;
              info.forEach(function (item) {
                if (includeTypes.includes(item.typename)) {
                  flag = true;
                }
              });

              if (!flag) {
                return res({
                  isSuccess: false,
                  info: info
                });
              }

              res({
                isSuccess: true,
                info: info
              });
            } else {
              res({
                isSuccess: false
              });
            }
          };

          fileReader.readAsArrayBuffer(file);
        } else {
          res({
            isSuccess: false
          });
        }
      });
    }
  }, {
    key: "countdown",
    value: function countdown(endTime, serverTime, callback) {
      var that = this,
          type = typeof serverTime === 'function',
          end = new Date(endTime).getTime(),
          now = new Date(!serverTime || type ? new Date().getTime() : serverTime).getTime(),
          count = end - now,
          time = [Math.floor(count / (1000 * 60 * 60 * 24)) //天
      , Math.floor(count / (1000 * 60 * 60)) % 24 //时
      , Math.floor(count / (1000 * 60)) % 60 //分
      , Math.floor(count / 1000) % 60 //秒
      ];
      if (type) callback = serverTime;
      var timer = setTimeout(function () {
        that.countdown(endTime, now + 1000, callback);
      }, 1000);
      callback && callback(count > 0 ? time : [0, 0, 0, 0], serverTime, timer);
      if (count <= 0) clearTimeout(timer);
      return timer;
    } // 判断是否是数字

  }, {
    key: "isNumeric",
    value: function isNumeric(val) {
      return !isNaN(parseFloat(val)) && isFinite(val);
    }
  }], [{
    key: "getCodeData",
    value: function getCodeData(pcodes) {
      return new Promise(function (resolve, reject) {
        postApi(DYC_URL['pes_dicConfigQueryData'], {
          configKeys: pcodes
        }).then(function (res) {
          resolve(res);
        });
      });
    } // 处理字典表数据

  }, {
    key: "handleDic",
    value: function handleDic(res) {
      var result = {},
          typeAndResult = [];

      if (res.data) {
        var arr = JSON.parse(JSON.stringify(res.data));

        _.each(arr, function (val, k) {
          result[k.replace('_', '&').split('&')[1].toUpperCase()] = val;
          typeAndResult.push({
            type: k.replace('_', '&').split('&')[0],
            code: k.replace('_', '&').split('&')[1].toUpperCase(),
            list: val
          });
        });
      }

      return Object.assign(res, {
        result: result,
        typeAndResult: typeAndResult
      });
    }
  }]);

  return Tool;
}();

export default new Tool();